export default function removeChangesFromLS(module, userId) {
  this.setStorage('stopChanges', "1")
  this.removeStorage('changes-' + module + '-' + userId)
}
